














































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import InputNumber from "@/components/common/input/InputNumber.vue";
import { InspectItem, InspectValueItem } from "@/model/InspectItem";
import { deepCopy, padNumber, getDate } from "@/service/util";
import { inspectService } from "@/service/inspectService.ts";
import { Getter } from "vuex-class";
import { CarSelectData } from "@/model/CarSelection";
import {
  INSPECT_VALUE_LENGTH,
  INSPECT_VALUE_VIEW_TYPE
} from "@/model/InspectValueViewType";
import * as util from "@/service/util";

@Component({
  components: {
    InputNumber
  }
})
export default class InspectValueDialog extends Vue {
  @Prop() inspect: InspectItem;
  @Prop() inspectList: InspectItem[];
  tempInspectList: InspectItem[] = [];
  inspectValueList: InspectValueItem[] = [];
  inspectValueLabelList: string[] = [];
  disabledSave: boolean = true;
  service: inspectService;
  isChange: boolean = false;
  hibi = ["fLeftTireHibi", "fRightTireHibi", "rLeftTireHibi", "rRightTireHibi"];
  isChangeHibi = false;
  defaultDateM: any = null;
  isAllCircle = false;
  isLED = false;
  isNotSetting = false;

  @Getter("currentState", { namespace: "CarSelection" })
  carSelData: CarSelectData;

  created() {
    this.service = new inspectService();
    switch (this.inspect.inspectValueViewType) {
      case INSPECT_VALUE_VIEW_TYPE.TIRE:
        this.inspectValueLabelList = [
          "左前 残り溝",
          "右前 残り溝",
          "左後 残り溝",
          "右後 残り溝"
        ];
        break;
      case INSPECT_VALUE_VIEW_TYPE.BRAKE:
      case INSPECT_VALUE_VIEW_TYPE.BRAKE_REAR:
        this.inspectValueLabelList = ["左残数", "右残数"];
        break;
      case INSPECT_VALUE_VIEW_TYPE.SUNFLARE:
        this.inspectValueLabelList = ["有効年月", ""];
        break;
      case INSPECT_VALUE_VIEW_TYPE.BOOTS:
        this.inspectValueLabelList = ["ヒビ割れ状態"];
        break;
      default:
        this.inspectValueLabelList = ["計測結果"];
        break;
    }

    if (this.inspectList && this.inspectList.length > 0) {
      this.disabledSave = false;
      this.tempInspectList = util.deepCopy(this.inspectList);
    } else {
      this.initInspectValue();
    }
  }

  initInspectValue() {
    const valLength = INSPECT_VALUE_LENGTH[this.inspect.inspectValueViewType];
    if (
      this.inspect.inspectValueList == null ||
      (this.inspect.inspectValueList &&
        this.inspect.inspectValueList.length == 0)
    ) {
      this.isChange = false;
      let list: InspectValueItem[] = [];

      for (let i = 0; i < valLength; i++) {
        list.push({ branchId: i + 1, inspectValue: null });
      }
      this.$set(this, "inspectValueList", list);
      this.disabledSave = true;
      if (this.inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.SUNFLARE) this.$set(this, "disabledSave", false);
    } else {
      if (
        this.inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.SUNFLARE
      ) {
        let list: InspectValueItem[] = [];
        const led = this.inspect.inspectValueList[0].inspectValue;
        const val = this.inspect.inspectValueList[0].inspectValueStr;
        if (led != null) {
          if (led == 1) {
            this.isLED = true;
            this.isNotSetting = false;
          } else if (led == 2) {
            this.isLED = false;
            this.isNotSetting = true;
          }
          for (let i = 0; i < valLength; i++) {
            list.push({ branchId: i + 1, inspectValue: null });
          }
        } else {
          if (val != null) {
            const val1 = parseInt(val.substring(0, 4));
            const val2 = parseInt(val.substring(4, 6));
            list.push({ branchId: 1, inspectValue: new Date(+val1, 1, 1) });
            list.push({ branchId: 2, inspectValue: new Date(val1, val2 - 1, 1) });
          }
        }
        this.$set(this, "inspectValueList", list);
      } else {
        const inspectValueList = deepCopy(this.inspect.inspectValueList);
        if (inspectValueList.length < valLength) {
          const iSatrt = inspectValueList.length;
          for (let i = iSatrt; i < valLength; i++) {
            inspectValueList.push({ branchId: i + 1, inspectValue: 0 });
          }
        }
        this.$set(this, "inspectValueList", inspectValueList);
      }
      this.checkDisableSave();
    }
  }

  onClose() {
    this.inspectValueList = [];
    this.inspect.showValue = false;
    this.$emit("onclose");
  }

  onConfirm() {
    if (!this.inspectList || this.inspectList.length === 0) {
      if (
        this.inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.SUNFLARE
      ) {
        let inspectValueList: any = [];
        if (this.isLED) {
          inspectValueList.push({ branchId: 1, inspectValue: 1 });
        } else if (this.isNotSetting) {
          inspectValueList.push({ branchId: 1, inspectValue: 2 });
        } else {
          const val1: any = this.inspectValueList[0].inspectValue;
          let val2: any = this.inspectValueList[1].inspectValue;
          let val = "";
          if (val1 && val1.toString() != 'Invalid Date' && val2 && val2.toString() != 'Invalid Date') {
            val =
              val1.getFullYear().toString() +
              padNumber((val2.getMonth() + 1).toString(), 2);
          }
          inspectValueList.push({ branchId: 1, inspectValueStr: val });
        }
        this.$emit("onconfirm", inspectValueList);
      } else {
        this.$emit("onconfirm", this.inspectValueList);
      }
      if (this.isChangeHibi) {
        this.$emit("onconfirm", this.inspectValueList);
      }
    } else if (this.tempInspectList) {
      this.$emit("onconfirmList", this.tempInspectList);
    }
    this.onClose();
  }

  checkDisableSave() {
    let disabledSave = this.service.checkDisableSaveInspectValue(
      this.inspectValueList,
      this.inspect.inspectValueViewType
    );
    if (this.inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.SUNFLARE) disabledSave = false;
    this.$set(this, "disabledSave", disabledSave);
  }

  focusInput(index: number, valIndex: number = 0) {
    if (index === 0 && valIndex === 0) {
      return true;
    }
    return false;
  }

  onInput(index: number = -1) {
    this.isChange = true;
    /** 2021-07-14 sh #7290 fix check timing. [START] */
    // this.checkDisableSave();
    this.onInputVal(index);
    this.checkDisableSave();
    /** 2021-07-14 sh #7290 fix check timing. [END] */
  }

  onChangeHibi() {
    this.isChangeHibi = true;
  }

  onChangeMonth() {
    if (this.inspectValueList[1].inspectValue) {
      this.inspectValueList[0].inspectValue = this.inspectValueList[1].inspectValue;
    }
    this.onInput();
  }

  onChangeYear() {
    if (this.inspectValueList[0].inspectValue != null) {
      const y = (this.inspectValueList[0].inspectValue as any)
        .getFullYear()
        .toString();
      let m = "01";
      if (this.inspectValueList[1].inspectValue != null) {
        m = padNumber(
          (
            (this.inspectValueList[1].inspectValue as any).getMonth() + 1
          ).toString(),
          2
        );
        this.inspectValueList[1].inspectValue = getDate(y + m + "01");
      }
      this.defaultDateM = getDate(y + m + "01");
    }
    this.onInput();
  }

  clickBoot(index: number, val: number) {
    const inspectValueList = this.tempInspectList[index].inspectValueList;
    if (inspectValueList != null && inspectValueList[0].inspectValue === val) {
      inspectValueList[0].inspectValue = null;
    }
  }

  clickHibi(val: number, index: number) {
    this.service.resetHibi(val, index, this.carSelData);
  }

  onInputVal(index: number) {
    if (
      this.inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.BRAKE ||
      this.inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.BRAKE_REAR ||
      this.inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.TIRE
    ) {
      if (index === 0) {
        this.inspectValueList[1].inspectValue = this.inspectValueList[0].inspectValue;
      } else if (index === 2) {
        this.inspectValueList[3].inspectValue = this.inspectValueList[2].inspectValue;
      }
    }
  }

  onInspectListInputVal(index: number, valIndex: number) {
    if (
      this.inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.BRAKE ||
      this.inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.BRAKE_REAR
    ) {
      if (valIndex === 0) {
        const inspectValueList = this.tempInspectList[index].inspectValueList;
        if (inspectValueList != null) {
          inspectValueList[1].inspectValue = inspectValueList[0].inspectValue;
        }
      }
    }
  }

  onCheckAllCircle() {
    this.tempInspectList.map((e: InspectItem) => {
      if (e.inspectValueList) {
        e.inspectValueList[0].inspectValue = this.isAllCircle ? 1: 0;
      }
    });
  }

  checkLED() {
    if (this.isLED) this.isNotSetting = false;
    this.$set(this, "disabledSave", !this.isLED);
  }

  checkNotSetting() {
    if (this.isNotSetting) this.isLED = false;
    this.$set(this, "disabledSave", !this.isNotSetting);
  }

  /** 2023-06-30 sh #8385(BQR1118) chagen Katakana from Han to Zen. [START] */
  dialogWidth(inspect: any) {
    if (inspect.inspectValueViewType && inspect.inspectValueViewType == 8) {
        return "600px";
    }

    return "450px";
  }
  /** 2023-06-30 sh #8385(BQR1118) chagen Katakana from Han to Zen. [END] */
}
